export default "__VITE_PUBLIC_ASSET__0109b706__"